<template>
	<section>
        <template>
            <div class="margin-top-10">
                <vForm label-width="150" ref="form">
                    <vFormItem label="SKU">
                        {{formData.sku}}
                    </vFormItem>
                    <vFormItem label="建议处理方式">
                        {{this.findRenderLabel(this.getHandleType, formData.goodsReturnType)|| '--'}}
                    </vFormItem>
                        <vFormItem label="认领数量/已处理数量">
                            {{formData.qty}}/{{formData.qtyDone}}
                        </vFormItem>
                        <vFormItem label="库存类型">
                            {{formData.goodsReturnType === 0 || formData.goodsReturnType === 2 ? '不可售库存' : formData.goodsReturnType === 3 ? '可售库存' : '--'}}
                        </vFormItem>
                        <vFormItem label="处理数量" :rules="required" prop="processQty">
                            <vInputNumber width="100px" v-model="formData.processQty" :max="formData.processQty" :min="1"></vInputNumber>
                        </vFormItem>
                </vForm>
			</div>
            <div class="text-right">
                <vButton class="margin-right-10" theme="primary" @click="submit">{{$t('global.modal.confirm', { defaultValue: "确定" })}}</vButton>
                <vButton @click="cancel">{{$t('global.common.operate_cancel', { defaultValue: "取消" })}}</vButton>
            </div>
		</template>
		<vLoading size="large" transfer :loading="loading"></vLoading>
		<compModal
			v-model="modalProps.show"
			v-bind="modalProps"
			@on-close="modalProps.show=false"
			@on-confirm="getDetail"
		>
			<component
				v-if="modalProps.component"
				:is="modalProps.component"
				v-bind="modalProps"
				v-on="modalProps.on"
			/>
		</compModal>
	</section>
</template>

<script>
import { HttpClaimPlanOrderHandle } from '@/service/salesreturns';
import mixin from "../mixin";
import { mapGetters } from 'vuex';
export default {
	mixins: [mixin],
    props: ["params"],
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		// compFormEdit: () => import("@components/templates/formedit"),
		compLog: () => import("@components/templates/log"),
		compModal: () => import("@components/templates/modal"),
	},
	data() {
		return {
			loading: false,
			id: this.params.obj.id,
            headId:this.params.headId,
			formData: {
                processQty:0
            },
			modalProps: {
				show: false,
			},
		};
	},
	created() {
        this.formData = this.params.obj
        this.formData.processQty = this.formData.qty - this.formData.qtyDone
	},
	computed: {
        ...mapGetters('dictionary', []),
        required () {
            return [
                {
                    required: true,
                    message: this.$t('global.common.fill_required', { defaultValue: '请填写必填项' })
                }
            ]
        },
	},
	methods: {
        clear(){
            this.formData.newProductId='';
            this.formData.newsku='';
        },
        async submit(){
            let flag = true;
                await this.$refs.form.validate(valid => {
                flag = valid;
            });
            if (!flag) return;
            this.loading = true;
            HttpClaimPlanOrderHandle({id:this.id, qty:this.formData.processQty}).then(res=>{
                this.loading = false;
                this.$emit('on-success')
            }).catch(err => {
                this.$VMessage.error(err.message);
            });
        },
		cancel() {
            this.$emit('on-success')
		}
	}
};
</script>
